<template>
    <div
            class="section-action-wrapper v-card v-sheet theme--light v-card--flat pa-3 my-2 border border-transparent rounded-lg chapter-section-selected"
            @mouseenter="showToolbar = true"
            @mouseleave="showToolbar = false"
    >

        <content-section-toolbar
                :visible="showToolbar"
                @copy="copyTextClicked"
                @bookmark="bookmarkClicked"
                @print="printClicked"
                @share="shareClicked"
        />

        <content-section-title
            :title="contentSection.title"
            :contentId="contentSection.sectionId"
            :documentId="contentSection.documentId"
            :isLink="isLink(contentSection)"/>

        <content-section-content
            :content="contentSection.content"
            :documentId="contentSection.documentId"
            @text-highlighted="textHighlighted"
            :sectionId="contentSection.sectionId"
            :contentModifiers="contentModifiers"/>

        <content-section-insights

        />
        <content-section-user-bookmarks

        />
        <content-section-breadcrumb
            v-if="contentSection?.breadcrumbs?.length !== 0"
            :breadcrumbs="contentSection?.breadcrumbs"
            @breadcrumb-clicked="handleBreadcrumbClick"
        />
    </div>
</template>

<script>
import ContentSectionToolbar from "./ContentSectionToolbar.vue";
import ContentSectionTitle from "./ContentSectionTitle.vue";
import ContentSectionContent from "./ContentSectionContent.vue";
import ContentSectionInsights from "./ContentSectionInsights.vue";
import ContentSectionUserBookmarks from "./ContentSectionUserBookmarks.vue";
import ContentSectionBreadcrumb from "./ContentSectionBreadcrumb.vue";
import ItemBreadcrumb from "../search/content/result/item_breadcrumb.vue";
import ContentSectionType from "./types/contentSectionType";
import {ClipboardUtils} from "../../util/ClipboardUtils";
import {DomUtils} from "../../util/DomUtils";
import {showNotification} from "../../global";
import ContentActions from "../titles/inc/contentActions";
import {SelectionUtil} from "../../util/SelectionUtil";
import {UrlUtil} from "../../util/UrlUtil";

export default {
    components: {
        ItemBreadcrumb,
        ContentSectionBreadcrumb,
        ContentSectionUserBookmarks,
        ContentSectionInsights,
        ContentSectionContent,
        ContentSectionTitle,
        ContentSectionToolbar
    },
    props: {
        /**
         * @type {ContentSectionType}
         */
        contentSection: {
            type: Object,
            required: true
        },
        /**
         * @type {Array<ContentModifier>}
         */
        contentModifiers: {
          type: Array,
          required: true
        }
    },
    mixins: [ContentActions],
    data() {
        return {
            showToolbar: false,
            highlightedText: null
        }
    },
    computed: {
        contentId() {
            return this.contentSection.contentId;
        },
        sectionId() {
            return this.contentSection.sectionId;
        },
        sectionTitle() {
            return this.contentSection.title;
        },
        documentId() {
            return this.contentSection.documentId;
        }
    },
    methods: {
        textHighlighted(selectionObject) {
            // TODO
        },
        handleBreadcrumbClick(breadcrumbItem) {
            this.$emit('breadcrumb-clicked', breadcrumbItem);
        },
        isLink(section){
            return !section.isChapter;
        },
        copyTextClicked() {

            const text = DomUtils.textFromHtml(this.contentSection.content);

            if (!text) {
                showNotification("No text to copy", "warning");
                return;
            }

            try {
                ClipboardUtils.copyTextToClipboard(text);
                showNotification("Text copied to clipboard");
            } catch (e) {
                console.error(e);
                showNotification('Failed to copy to clipboard', 'error');
            }
        },
        bookmarkClicked() {

            const selectedText = SelectionUtil.getSelectedText();

            // if any text is selected, then we are adding a NOTE
            if (selectedText.length > 0) {
                this.toggleNoteActionNew(null, {
                    sectionId: this.sectionId,
                    document_id: this.documentId,
                    highlightedText: selectedText,
                });
            } else {
                this.toggleBookmarkActionNew({
                    sectionTitle: this.sectionTitle,
                    sectionId: this.sectionId,
                    document_id: this.documentId
                });
            }
        },
        printClicked() {

            // TODO: make this dynamic
            let tableWidth = 998;
            let printAllSections = false;

            const printUrl = Routing.generate('print_content', {
                'documentId': btoa(this.documentId),
                'chapterId': btoa(0), // when 0, it will fetch chapterId for you on the backend
                'sectionId': btoa(this.sectionId),
                'tableWidth': tableWidth,
                'printAll': printAllSections ? 1 : 0,
            });

            window.open(printUrl, '_blank');
        },
        shareClicked() {

            // TODO: maybe get exact URL from: https://codes.iccsafe.org/api/content/get-url-slug/2217/24202559
            const sectionLink = Routing.generate('content_id_redirect', {
                'contentId': this.sectionId
            });

            const fullUrl = UrlUtil.relativeToAbsolute(sectionLink);

            try {
                ClipboardUtils.copyTextToClipboard(fullUrl);
                showNotification('Link copied to clipboard');
            } catch (e) {
                console.error(e);
                showNotification("Failed to copy to clipboard", "error");
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>